import { render, staticRenderFns } from "./ShopStat.vue?vue&type=template&id=7298ba2a&scoped=true&"
import script from "./ShopStat.vue?vue&type=script&lang=js&"
export * from "./ShopStat.vue?vue&type=script&lang=js&"
import style0 from "./ShopStat.vue?vue&type=style&index=0&id=7298ba2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7298ba2a",
  null
  
)

export default component.exports